import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    EuiIconModule,
    EuiBadgeModule,
} from '../../components';

import { EuiOverlayModule } from '../eui-overlay';

import { EuiNotificationsComponent } from './eui-notifications.component';

@NgModule({
    imports: [
        CommonModule,
        EuiBadgeModule,
        EuiIconModule,
        EuiOverlayModule,
    ],
    declarations: [
        EuiNotificationsComponent,
    ],
    exports: [
        EuiNotificationsComponent,
    ],
})
export class EuiNotificationsModule { }
